import useAuth from "hooks/useAuth";
import { APP_URLS } from "urls/AppUrls";
import { Navigate } from "react-router";
import RouterLoadingScreen from "components/loading-screen/RouterLoadingScreen";
import Error403Page from "pages/errors/Error403Page";
import { SYSTEM_CLAIM_TYPES } from "constants/system-claim-types";

// ----------------------------------------------------------------------

type PermissionBasedGuardProps = {
  permissions?: string[];
  children?: React.ReactNode;
  redirectElement?: React.ReactNode;
};

export default function PermissionBasedGuard({ permissions, children, redirectElement }: PermissionBasedGuardProps) {
  const { isAuthenticated, isInitialized, user } = useAuth();
  
  if (!isInitialized) {
    return <RouterLoadingScreen />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={APP_URLS.LOGIN} />;
  }

  const currentPermissions = user?.claims?.filter(s => s.claimType === SYSTEM_CLAIM_TYPES.PERMISSION).map(r => `${r.claimValue}`); 
  if (
    typeof permissions !== "undefined" &&
    currentPermissions &&
    !permissions.some((r) => currentPermissions.includes(r))
  ) {
    if (redirectElement) {
      return <>{redirectElement}</>;
    }

    return (
      <>
       <Error403Page />
      </>
    );
  }

  return <>{children}</>;
}
